<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="col pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col pt-0">
                  <v-combobox v-model="client_selected" autocomplete="off" item-text="name" item-value="id" :items="clients" label="Cliente" class="pt-0 mt-0" clearable></v-combobox>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <v-card v-if="list_access">
        <v-card-title>
          <v-btn color="blue-grey" class="mt-3" small dark :loading="dialog_export" @click="exportToExcel">
            Exportar
            <font-awesome-icon class="ml-2" icon="download"
          /></v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.nro_recibo }}</td>
              <td>{{ props.item.fecha_cobro }}</td>
              <td>{{ props.item.client_name }}</td>
              <td>{{ props.item.salesman_name }}</td>
              <td>{{ props.item.tipo }}</td>
              <td>{{ props.item.fecha_comprobante }}</td>
              <td>{{ props.item.comprobante }}</td>
              <td>{{ props.item.fecha_valor }}</td>
              <td>{{ props.item.type_payment }}</td>
              <td>{{ props.item.nro_valor }}</td>
              <td>{{ props.item.moneda }}</td>
              <td>{{ formatUtils.formatPrice(props.item.total) }}</td>
              <td>{{ props.item.condicion }}</td>
              <td>{{ formatUtils.formatPrice(props.item.ponderacion_total) }}</td>
              <td>{{ props.item.ponderacion }}</td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Constant from "@/constants/sections";
import { clientsService } from "@/libs/ws/clientsService";
import { reportService } from "@/libs/ws/reportService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, SettingsMixin, ExportMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: reportService,
      page_title: "Reporte Ponderacion de Cobros",
      modal_title: "Reporte Ponderacion de Cobro",
      headers: [
        { text: "N° Cobro", align: "left", sortable: true, value: "nro_recibo" },
        { text: "Fecha de Cobro", align: "left", sortable: true, value: "fecha_cobro" },
        { text: "Cliente", align: "left", sortable: true, value: "client_name" },
        { text: "Vendedor", align: "left", sortable: true, value: "salesman_name" },
        { text: "Tipo de Comprobante", align: "left", sortable: true, value: "tipo" },
        { text: "F. Comprobante", align: "left", sortable: true, value: "fecha_comprobante" },
        { text: "N° de Comprobante", align: "left", sortable: true, value: "comprobante" },
        { text: "F. Valor", align: "left", sortable: true, value: "fecha_valor" },
        { text: "Medio de pago", align: "center", sortable: true, value: "type_payment" },
        { text: "N° Valor", align: "center", sortable: true, value: "nro_valor" },
        { text: "Moneda", align: "center", sortable: true, value: "moneda" },
        { text: "Total", align: "center", sortable: true, value: "total" },
        { text: "Cond.", align: "center", sortable: true, value: "condicion" },
        { text: "#", align: "center", sortable: true, value: "ponderacion_total" },
        { text: "Ponderacion", align: "center", sortable: true, value: "ponderacion" },
      ],
      list: [],
      clients: [],
      open_generate_order: false,
      desde_selected_open: false,
      hasta_selected_open: false,
      client_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
    };
  },
  mounted() {
    this.loadComboData();
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    loadList(service, param = null) {
      this.loading = true;
      if (param == null) {
        param = this.getFilterParams();
      }
      this.open_filter = false;
      service
        .getReportsPonderacionCharge(param)
        .then((response) => {
          console.log("response", response);
          this.list = response.result;
          this.loading = false;
          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.getReportsPonderacionCharge error");
          console.log(e);
          this.loading = false;
        });
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        client: this.client_selected != null ? this.client_selected.id : null,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      clientsService.filterMinify().then((response) => {
        this.clients = response.result;
      });
    },
    exportToExcel() {
      var param = this.getFilterParams();
      param["export"] = true;
      let fileName = "Reporte-Ponderacion-Cobro.xlsx";
      this.exportExcel(Constant.SECTION_REPORTS + "/ponderacion-charges", param, fileName);
    },
  },
};
</script>
